import Search from "@iso/containers/Pages/Search/Search";
import Dashboard from '@iso/containers/Pages/Dashboard/Dashboard';
import Property from '@iso/containers/Pages/Property/Property';
import HealthSafety from '@iso/containers/Pages/HealthSafety/Dashboard';
import SafetyDocumentsPage from '@iso/containers/Pages/HealthSafety/SafetyDocumentsPage';
import PropertyMap from '@iso/containers/Pages/PropertyMap/PropertyMap';
import Mob from '@iso/containers/Pages/Mob/Mob';
import Task from '@iso/containers/Pages/Task/Task';
import LiveStock from '@iso/containers/Pages/LiveStock/LiveStock';
import PropertyArea from '@iso/containers/Pages/PropertyArea/PropertyArea';
import SafeFarm from '@iso/containers/Pages/SafeFarm/SafeFarm';
import Profile from '@iso/containers/Pages/Profile/Profile';
import Asset from '@iso/containers/Pages/Asset/Asset';
import AssetPassport from '@iso/containers/Pages/Asset/AssetPassport';
import EducationAsset from '@iso/containers/Pages/Asset/EducationAsset';
import Weather from '@iso/containers/Pages/Weather/Weather';
import { Form } from '@iso/containers/Pages/Form/Form';
import Marketplace from '@iso/containers/Pages/Marketplace/Marketplace';
import ProductDetail from '@iso/containers/Pages/Marketplace/ProductDetail';
import ProductList from '@iso/containers/Pages/Marketplace/ProductList';
import ManageUserProduct from '@iso/containers/Pages/ManageUserProduct/ManageUserProduct';
import AdminDashboard from '@iso/containers/Pages/AdminPages/Dashboard/Dashboard';
import ManageProductCategory from '@iso/containers/Pages/AdminPages/ManageProductCategory/ManageProductCategory';
import Directory from '@iso/containers/Pages/Directory/Directory';
import ShareMap from '@iso/containers/Pages/ShareMap/ShareMap';
import FormSubmission from '@iso/containers/Pages/Form/FormSubmission';
import TrainingSessionRegister from '@iso/containers/Pages/TrainingSessionRegister';
import Inspection from '@iso/containers/Pages/Form/Inspection';
import Visitor from '@iso/containers/Pages/Visitor/Visitor';
import Contractors from '@iso/containers/Pages/Contractor/Contractors';
import ContractorProfile from '@iso/containers/Pages/Contractor/ContractorProfile';
import AddContractorWizard from '@iso/containers/Pages/Contractor/AddContractorWizard';
import StopDeviceAlarmRequest from "@iso/containers/Pages/StopDeviceAlarmRequest/StopDeviceAlarmRequest";
import VerifyElapsedPage from "@iso/containers/Pages/VerifyElapsedPage/VerifyElapsedPage";
import Sensors from '@iso/containers/Pages/Sensors/Sensors';
import SensorDetail from '@iso/containers/Pages/Sensors/SensorDetail';
import IncidentList from "@iso/containers/Pages/Incident/IncidentList";
import InvestigationSelection from "@iso/containers/Pages/Incident/InvestigationSelection";
import FiveWhysInvestigation from "@iso/containers/Pages/Incident/FiveWhysInvestigation";
import ICAMInvestigation from "@iso/containers/Pages/Incident/ICAMInvestigation";
import FactualInvestigation from "@iso/containers/Pages/Incident/FactualInvestigation";
import CorrectiveActionsPage from "@iso/containers/Pages/Incident/CorrectiveActionsPage";
import LessonsLearnedPage from "@iso/containers/Pages/Incident/LessonsLearnedPage";
import Spray from '@iso/containers/Pages/Spray/Spray';
import SprayJobCreate from '@iso/containers/Pages/Spray/SprayJobCreate';
import SprayJobDetail from '@iso/containers/Pages/Spray/SprayJobDetail';
import SprayJobPrepare from '@iso/containers/Pages/Spray/SprayJobPrepare';
import SprayJobSpray from '@iso/containers/Pages/Spray/SprayJobSpray';
import SprayJobCleanup from '@iso/containers/Pages/Spray/SprayJobCleanup';
import Activity from "@iso/containers/Pages/Activity/Activity";
import ThankYou from "@iso/containers/Pages/ThankYou/ThankYou";
import PropertySettings from "@iso/containers/Pages/Property/PropertySettings/PropertySettings";
import HolidayManagement from "@iso/containers/Pages/Property/HolidayManagement/HolidayManagement";
import RoleAssignment from "@iso/containers/Pages/Property/RoleAssignment/RoleAssignment";
import UserAccess from "@iso/containers/Pages/Property/UserAccess/UserAccess";
import HazardList from '@iso/containers/Pages/HazardManagement/HazardList';
import HazardDetailView from '@iso/containers/Pages/HazardManagement/HazardDetailView';
import CorporateReporting from '@iso/containers/Pages/CorporateReporting/CorporateReporting';
import FileManager from '@iso/containers/Pages/FileManager/FileManager';
import SDS from '@iso/containers/Pages/SDS/SDS';
import Training from '@iso/containers/Pages/Training';
import DeepLinkRedirect from '@iso/containers/Pages/DeepLink/DeepLinkRedirect';
import OperationsDashboard from '@iso/containers/Pages/Operations/Dashboard';
import OperationsTaskboard from '@iso/containers/Pages/Operations/Taskboard';
import OperationsPlanner from '@iso/containers/Pages/Operations/Planner';
import OperationsTeamSchedule from '@iso/containers/Pages/Operations/TeamSchedule';
import OperationsTimeTracker from '@iso/containers/Pages/Operations/TimeTracker';
import OperationsTimesheets from '@iso/containers/Pages/Operations/Timesheets';

export default {
  Dashboard: {
    component: Dashboard,
    path: '/dashboard'
  },
  OperationsDashboard: {
    component: OperationsDashboard,
    path: '/operations/dashboard'
  },
  OperationsTaskboard: {
    component: OperationsTaskboard,
    path: '/operations/taskboard'
  },
  OperationsPlanner: {
    component: OperationsPlanner,
    path: '/operations/planner'
  },
  OperationsTeamSchedule: {
    component: OperationsTeamSchedule,
    path: '/operations/team-schedule'
  },
  OperationsTimeTracker: {
    component: OperationsTimeTracker,
    path: '/operations/time-tracker'
  },
  OperationsTimesheets: {
    component: OperationsTimesheets,
    path: '/operations/timesheets'
  },
  Property: {
    component: Property,
    path: '/manage-properties'
  },
  PropertyMap: {
    component: PropertyMap,
    path: '/map'
  },
  Mob: {
    component: Mob,
    path: '/manage-mobs'
  },
  LiveStock: {
    component: LiveStock,
    path: '/manage-livestocks'
  },
  Sensors: {
    component: Sensors,
    path: '/manage-sensors'
  },
  Task: {
    component: Task,
    path: '/manage-tasks'
  },
  PropertyArea: {
    component: PropertyArea,
    path: '/manage-areas'
  },
  Profile: {
    component: Profile,
    path: '/profile'
  },
  Asset: {
    component: Asset,
    path: '/manage-assets'
  },
  AssetPassport: {
    component: AssetPassport,
    path: '/asset-passport/:token'
  },
  EducationAsset: {
    component: EducationAsset,
    path: '/manage-education-assets'
  },
  Weather: {
    component: Weather,
    path: '/weather'
  }, 
  HealthSafety: {
    component: HealthSafety,
    path: '/health-safety'
  },
  SafetyDocuments: {
    component: SafetyDocumentsPage,
    path: '/safety-documents'
  },
  SafeFarm: {
    component: SafeFarm,
    path: '/safe-farm'
  },
  Form: {
    component: Form,
    path: '/manage-forms'
  },
  Marketplace: {
    component: Marketplace,
    path: '/marketplace'
  },
  ProductDetail: {
    component: ProductDetail,
    path: '/product-detail'
  },
  ProductList: {
    component: ProductList,
    path: '/product-list'
  },
  ManageUserProduct: {
    component: ManageUserProduct,
    path: '/manage-your-product'
  },
  Directory: {
    component: Directory,
    path: '/directory'
  },
  Search: {
    component: Search,
    path: '/search'
  },
  ShareMap: {
    component: ShareMap,
    path: '/share-map'
  },
  FormSubmission: {
    component: FormSubmission,
    path: '/form-submission'
  },
  TrainingSessionRegister: {
    component: TrainingSessionRegister,
    path: '/training-session/register/:id'
  },
  inspection: {
    component: Inspection,
    path: '/manage-inspection'
  },
  Visitor: {
    component: Visitor,
    path: '/manage-visitor'
  },
  VisitorForm: {
    component: FormSubmission,
    path: '/visitor-form'
  },
  ContractorForm: {
    component: FormSubmission,
    path: '/contractor-form'
  },
  // Contractor module — order matters: more specific paths first so
  // /contractors/new and /contractors/:id/edit resolve before
  // /contractors/:id, which resolves before /contractors.
  ContractorAdd: {
    component: AddContractorWizard,
    path: '/contractors/new'
  },
  ContractorEdit: {
    component: AddContractorWizard,
    path: '/contractors/:id/edit'
  },
  ContractorProfile: {
    component: ContractorProfile,
    path: '/contractors/:id'
  },
  Contractors: {
    component: Contractors,
    path: '/contractors'
  },
  StopDeviceAlarmRequest: {
    component: StopDeviceAlarmRequest,
    path: '/stop-device-alarm-request'
  },
  VerifyElapsedPage: {
    component: VerifyElapsedPage,
    path: "/sar-elapsed-time",
  },
  SensorDetail: {
    component: SensorDetail,
    path: "/sensor-detail/:sensorId",
  },
  Spray: {
    component: Spray,
    path: '/spray'
  },
  Incident: {
    component: IncidentList,
    path: '/incidents'
  },
  InvestigationSelection: {
    component: InvestigationSelection,
    path: '/incidents/:incidentId/investigation-selection'
  },
  FiveWhysInvestigation: {
    component: FiveWhysInvestigation,
    path: '/incidents/:incidentId/investigation/five-why'
  },
  ICAMInvestigation: {
    component: ICAMInvestigation,
    path: '/incidents/:incidentId/investigation/icam'
  },
  FactualInvestigation: {
    component: FactualInvestigation,
    path: '/incidents/:incidentId/investigation/factual'
  },
  CorrectiveActionsPage: {
    component: CorrectiveActionsPage,
    path: '/incidents/:incidentId/corrective-actions'
  },
  LessonsLearnedPage: {
    component: LessonsLearnedPage,
    path: '/incidents/:incidentId/lessons-learned'
  },
  SprayJobCreate: {
    component: SprayJobCreate,
    path: '/spray-job/create'
  },
  SprayJobEdit: {
    component: SprayJobCreate,
    path: '/spray-job/edit/:id'
  },
  SprayJobPrepare: {
    component: SprayJobPrepare,
    path: '/spray-job/:id/prepare'
  },
  SprayJobSpray: {
    component: SprayJobSpray,
    path: '/spray-job/:id/spray'
  },
  SprayJobCleanup: {
    component: SprayJobCleanup,
    path: '/spray-job/:id/cleanup'
  },
  SprayJobDetail: {
    component: SprayJobDetail,
    path: '/spray-job/:id'
  },
  Activity: {
    component: Activity,
    path: '/activity'
  },
  ThankYou: {
    component: ThankYou,
    path: "/thank-you",
  },
  PropertySettings: {
    component: PropertySettings,
    path: "/property-settings",
  },
  HolidayManagement: {
    component: HolidayManagement,
    path: "/holiday-management",
  },
  RoleAssignment: {
    component: RoleAssignment,
    path: "/role-assignment",
  },
  UserAccess: {
    component: UserAccess,
    path: "/user-access",
  },
  HazardDetailView: {
    component: HazardDetailView,
    path: '/hazards/:id'
  },
  HazardList: {
    component: HazardList,
    path: '/hazards'
  },
  CorporateReporting: {
    component: CorporateReporting,
    path: '/corporate-reporting'
  },
  FileManager: {
    component: FileManager,
    path: '/file-manager'
  },
  SDS: {
    component: SDS,
    path: '/sds'
  },
  Training: {
    component: Training,
    path: '/training-module'
  },
  DeepLinkRedirect: {
    component: DeepLinkRedirect,
    path: '/l/:type/:id'
  }
};
